<template>
	<div>
		<top-app-bar-drawer></top-app-bar-drawer>
		<main class="main-wrapper flex-grow-1">
			<div class="container container--narrow pdt-50">
				<div class="t-headline10 font-b t-line-h-30">
					{{$t('277')}}
				</div>
				<div class="t-body1 mgt-6 fornt-r t-color-bodyGrayA mgt-8">
					{{$t('278')}}
					<!-- 프로필로 사용할 패턴을 설정하세요. -->
				</div>
				<div class="mgt-24">
					 <div class="d-flex justify-content-center pdt-50 pdb-50 profile-wrap" :style="{'background': backgroundColor}">
						<div class=" pdt-42 pdb-42" :style="{'background': backgroundColor}">
								<canvas id="pattenCanvas" ref="pattenCanvas" width="320" height="314" class="cursor-pointer"> </canvas>
						</div>
					</div>
				</div>
				<div class="mgt-24">
					<div class="d-flex justify-content-end t-color-bodyGrayA">
						<div class="d-flex justify-content-center align-items-center mgr-8 mgl-8">
							<div class="t-body2 mgr-8 mgl-8">
								{{$t('279')}}
								<!-- 배경색 -->
							</div>
							<verte menuPosition="center" 
								class="select-color-picker"
								:style="{'background': backgroundColor}"
								@input="updateBackgroundColor" model="hex" :value="backgroundColor">
							</verte>
						</div>
						<div class="d-flex justify-content-center align-items-center mgr-8 mgl-8">
							<div class="t-body2 mgr-8 mgl-8">
								{{$t('280')}}
								<!-- 패턴색 -->
							</div>
							<verte menuPosition="center" 
								class="select-color-picker"                        
								:style="{'background': pattenColor}"
								@input="updatePattenColor" model="hex" :value="pattenColor">                        
							</verte>
						</div>
					</div>
				</div>
				<div class="mgt-50 mgb-50">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" tabindex="0" @click="saveImage()" @keypress="saveImage()">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r"> {{$t('281')}}</span>
					</button>
					<button class="mdc-button bg-white t-color-secondaryBtnText b-radius4" tabindex="0" @click="goBack" @keypress="goBack">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('5')}}</span>
					</button>
				</div>
			</div>
		</main>
	</div>	
</template>
<script>
/**
 * 멤버십 - 프로필 패턴 변경 컴포넌트(membership - change profile patten component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import Verte from 'verte'
import 'verte/dist/verte.css'
import httpService from '@/api/httpService.js'
import memberApi from '@/api/memberApi.js'
import {MDCRipple} from '@material/ripple'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
export default {
	components: {
		Verte,
		TopAppBarDrawer
	},
	data() {
		return {
			elemCanvas: null,
			context: null,
			elements: [],
			rectWidth: 0,
			rectHeight: 0,
			padding: 15,
			defaultColor: "#dbdbdb",
			backgroundColor: "#f6f8f9",
			pattenColor: "rgba(118, 160, 214, 0.7)",
			pattenValue: [],
		}
	},
	mounted() {    
		this.setMaterialUi()
		// 캔버스 그리기(create canvas)
		this.elemCanvas = this.$refs.pattenCanvas
		this.context = this.elemCanvas.getContext("2d"); // 캔버스 객체 생성
		// 캔버스 화면 지우기(clear canvas)
		this.context.clearRect(0, 0, this.elemCanvas.width, this.elemCanvas.height);
		let rectX = 0;
		let rectY = 0;
		let rectWidth = this.elemCanvas.width / 4 - (this.padding * 2) ;
		let rectHeight = this.elemCanvas.height / 4 - (this.padding * 2) ;
		let cornerRadius = 5;		
		// 라운드 설정(set round canvas)
		this.context.lineJoin = "round";
		this.context.lineWidth = cornerRadius;
		this.context.beginPath();
		
		// 캔버스 요소 정보 설정(set canvas element information)
		for(let i=1 ; i <= 4; i++) {
			rectY = this.padding*((i-1)+i) + rectHeight*(i-1)
		//	console.log(rectY, ' __rectY')
			for(let j=1 ; j <= 4; j++) {
				rectX = this.padding * ((j-1)+j)+ ((rectWidth) * (j-1))
				this.elements.push({
					colour: this.defaultColor,
					width: rectWidth-cornerRadius,
					height: rectHeight-cornerRadius,
					top: rectY+(cornerRadius/2),
					left: rectX+(cornerRadius/2),
					text: (i-1)*4+j,
					textColour: 'var(--DocumentWhite)'
				})
			}
		}


		let elemLeft = this.elemCanvas.offsetLeft
		let elemTop = this.elemCanvas.offsetTop
  //console.log(this.elemCanvas.offsetLeft, elemTop, ' __this.elemCanvas')
		// 캔버스 클릭 이벤트 설정(set event canvas click)
		this.elemCanvas.addEventListener('click', (event) => {
			let x = event.pageX - elemLeft
			let y = event.pageY - elemTop
		//	console.log('click');
			this.elements.forEach((element, index) => {
				//console.log(element.text ,element);
				if (y > element.top && y < element.top + element.height + cornerRadius && x > element.left && x < element.left + element.width + cornerRadius) {
					if (element.colour !== this.defaultColor) {
						element.colour = this.defaultColor
						this.pattenValue[index] = 0
					}else {
						element.colour = this.pattenColor
						this.pattenValue[index] = 1
					}
					this.pattenValue.push()
					this.drawPatten()
				}
			});
		}, false);
		
		// 프로필 패턴 정보 API 호출(get profile patten)
		memberApi.getProileImage().then((response)=>{
			let profileData = response.data.data
			if (profileData) {
				this.defaultColor = profileData.defaultColor || this.defaultColor
				this.backgroundColor = profileData.backgroundColor || this.backgroundColor
				this.pattenColor = profileData.pattenColor || this.pattenColor
				if (!profileData.pattenValue.length) {
					this.pattenValue = [0,0,0,0,
										0,0,0,0,
										0,0,0,0,
										0,0,0,0]

				}else {
					this.pattenValue = profileData.pattenValue
				}

				// 패턴 이미지 색상 설정(set patten color)
				this.elements.forEach((element, index) => {
					// console.log(index);
					if (this.pattenValue[index] === 1) {
						element.colour = this.pattenColor
					} else {
						element.colour = this.defaultColor
					}
				})
				
				this.drawPatten()
			}
		})
		
	},

	methods: {
				goBack(){
			this.$router.go(-1)
		},
		// 패턴 그리기(draw patten)
		drawPatten() {
			this.context.clearRect(0, 0, this.elemCanvas.width, this.elemCanvas.height)
			this.context.fillStyle = this.backgroundColor
			this.context.fillRect(0,0,this.elemCanvas.width, this.elemCanvas.height)
			// console.log('elements',this.elemCanvas.width, this.elements);
			this.elements.forEach((element, eleIndex) => {// 선 색(line color)
						this.context.beginPath();
						this.context.strokeStyle = '#dbdbdb'; 
						this.context.fillStyle = '#dbdbdb';
						this.context.moveTo(element.left+20, element.top+20);
						this.context.arc(element.left+20, element.top+20, 10, 0, Math.PI * 2, true);
						this.context.fill();
				if('#dbdbdb' !== element.colour){
						this.context.beginPath();
						this.context.strokeStyle = element.colour; 
						this.context.fillStyle = element.colour;
						this.context.moveTo(element.left +20.5, element.top +20.5);
						this.context.arc(element.left +20.5, element.top +20.5, 22, 0, Math.PI * 2, true);
						this.context.fill();
				}
				//this.context.strokeRect(element.left, element.top, element.width, element.height)
			//	this.context.fillRect(element.left, element.top, element.width, element.height)
			})
		},

		// 이미지 업로드 및 프로필 저장(Upload image and save profile)
		saveImage() {
			 let canvasData = this.elemCanvas.toDataURL("image/png");
			 let blob = this.dataURItoBlob(canvasData);

			 let formData = new FormData()
			 formData.append('file', blob, 'profile.png')

			 httpService.upload(formData)
				.then((response) => {
					let params = {
						file: response.data.data[0],
						backgroundColor: this.backgroundColor,
						defaultColor: this.defaultColor,
						pattenColor: this.pattenColor,
						pattenValue: this.pattenValue,
					}

					memberApi.uploadProileImage(params).then((response)=>{
						this.$snackOpen({
							contents: this.$t('3329'),
							btnDisplayYN: false,
							btnDisplay: ''
						}).then(() => {})
						
					})
					
				})
				.catch((err) => {
					console.log('FAILURE!!', err);
				});
			
		}, 

		// Color Picker 배경색 설정(set background color)
		updateBackgroundColor(value) {
			// console.log('updateBackgroundColor', value);
			this.backgroundColor = value
			this.drawPatten()
		},

		// Color Picker 패턴색 설정(set patten color)
		updatePattenColor(value) {
			// console.log('updatePattenColor', value);
			this.pattenColor = value
			this.elements.forEach((element) => {
				if (element.colour !== this.defaultColor) {
					element.colour = this.pattenColor
				}
			})
			this.drawPatten()
		},

		// 파라미터 설정(set parameter)
		setParams() {
			let params = {
				backgroundColor: this.backgroundColor,
				defaultColor: this.defaultColor,
				pattenColor: this.backgroundColor,
				pattenValue: []
			}

			this.elements.forEach((element) => {
				if (element.colour !== this.defaultColor) {
					params.pattenValue.push(1)
				}else {
					params.pattenValue.push(0)
				}
			})
		},
		
		// 캔버스 이미지 전송위한 Blob 함수(Blob function for canvas image transfer)
		dataURItoBlob(dataURI) {
			// convert base64/URLEncoded data component to raw binary data held in a string
			let byteString
			if (dataURI.split(',')[0].indexOf('base64') >= 0){
				byteString = atob(dataURI.split(',')[1])
			}else {
				byteString = unescape(dataURI.split(',')[1])
			}

			// separate out the mime component
			let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

			// write the bytes of the string to a typed array
			let ia = new Uint8Array(byteString.length)
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i)
			}
			return new Blob([ia], {type:mimeString})
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}
</script>

<style scoped>
	.profile-wrap {
		border: 1px solid #dbdbdb;
	}
</style>